import React from "react";
import { useCart } from "react-use-cart";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./cart.css";

function Cart() {
  const { isEmpty, cartTotal, items, updateItemQuantity, emptyCart } =
    useCart();
  if (isEmpty) return <h1 className="text-center py-4 ">Your Cart is Empty</h1>;
  return (
    <div>
      <div className="cart_header  ">
        <div
          className="container"
          style={{ fontSize: "20px", fontFamily: "-moz-initial" }}
        >
          <h3>
            <b>Cart</b>
          </h3>

          <p className="text-muted"> e-temp/cart </p>
        </div>
      </div>
      <section className="py-2 container">
        <div className="contaienr text-light contiShop ">
          Items/Item has been added to your cart{" "}
          <Link
            to="/shop"
            className="text-warning"
            style={{
              textDecoration: "none",
            }}
          >
            <b>Continue Shopping</b>
          </Link>
        </div>
        <div className=" cart_main  py-5 ">
          <div className="cart_left">
            <Container>
              <Row>
                <Col>
                  <b> Product </b>
                </Col>

                <Col>
                  <b> Price </b>
                </Col>
                <Col>
                  <b> Quantity </b>
                </Col>
              </Row>
            </Container>
            <hr />
            <div>
              {items.map((item) => {
                return (
                  <>
                    <Row>
                      <Col>
                        <img
                          src={`http://localhost:8000/uploads/${item.image}`}
                          alt=""
                          style={{ height: "5rem" }}
                        />
                        <i style={{ marginLeft: "15px" }}>{item.name}</i>
                      </Col>

                      <Col>
                        <p style={{ margin: "25px 0px 5px 0px " }}>
                          {item.price} $
                        </p>
                      </Col>
                      <Col
                        style={{
                          display: "flex",
                          padding: "20px 0px 20px 0px ",
                        }}
                      >
                        <Button
                          variant="outline-danger"
                          onClick={() =>
                            updateItemQuantity(item.id, item.quantity - 1)
                          }
                        >
                          -
                        </Button>

                        <p style={{ margin: "15px 5px 15px 5px " }}>
                          {item.quantity}
                        </p>
                        <Button
                          variant="outline-success"
                          onClick={() =>
                            updateItemQuantity(item.id, item.quantity + 1)
                          }
                        >
                          +
                        </Button>
                      </Col>
                    </Row>
                  </>
                );
              })}
              <div style={{ paddingTop: "15px" }}>
                <Button
                  variant="warning"
                  style={{ borderRadius: "5px" }}
                  onClick={() => emptyCart()}
                >
                  Clear Cart
                </Button>
              </div>
            </div>
          </div>
          <div className="cart_right">
            <h4> Cart totals : </h4>
            <br />
            <div>
              <b>Delivery</b>
              <span style={{ marginLeft: "150px" }}> C.O.D </span>
              <hr />
            </div>
            <div>
              <b>Shipping</b>
              <span style={{ marginLeft: "150px" }}> Calculate </span>
              <hr />
            </div>
            <b>
              <h4>
                Total
                <i style={{ marginLeft: "150px", color: "royalblue" }}>
                  {cartTotal}$
                </i>
              </h4>
            </b>
            <br />
            <div className="text-center">
              <Link to="/oder">
                <Button
                  variant="danger"
                  size="lg"
                  style={{
                    borderRadius: "50px",
                    padding: "5px 40px 5px 40px ",
                  }}
                >
                  Proccess to Checkout
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Cart;
